import { supabase } from "@/integrations/supabase/client";

class TelegramService {
  private static instance: TelegramService;
  private ws: WebSocket | null = null;

  private constructor() {}

  public static getInstance(): TelegramService {
    if (!TelegramService.instance) {
      TelegramService.instance = new TelegramService();
    }
    return TelegramService.instance;
  }

  private getWebSocketUrl(): string {
    const isProduction = window.location.hostname !== 'localhost';
    return isProduction 
      ? `wss://${window.location.hostname}/telegram-ws`
      : `ws://localhost:8080/telegram`;
  }

  public async initialize(onMessage: (message: any) => void) {
    try {
      if (this.ws) {
        console.log('Fechando conexão WebSocket existente...');
        this.ws.close();
      }

      const wsUrl = this.getWebSocketUrl();
      console.log('Conectando ao WebSocket do Telegram:', wsUrl);
      
      this.ws = new WebSocket(wsUrl);

      this.ws.onopen = () => {
        console.log('WebSocket do Telegram conectado com sucesso');
      };

      this.ws.onmessage = (event) => {
        console.log('Mensagem WebSocket recebida:', event.data);
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'message') {
            onMessage(data.data);
          }
        } catch (error) {
          console.error('Erro ao processar mensagem:', error);
        }
      };

      this.ws.onerror = (error: Event) => {
        console.error('Erro na conexão WebSocket:', error);
      };

      this.ws.onclose = () => {
        console.log('Conexão WebSocket fechada');
      };

    } catch (error) {
      console.error('Erro ao inicializar Telegram:', error);
      throw error;
    }
  }

  public async sendMessage(chatId: string, message: string) {
    try {
      if (!this.ws) {
        throw new Error('WebSocket não está conectado');
      }

      this.ws.send(JSON.stringify({
        type: 'sendMessage',
        chatId,
        content: message
      }));

      return true;
    } catch (error) {
      console.error('Erro ao enviar mensagem:', error);
      throw error;
    }
  }
}

export const telegramService = TelegramService.getInstance();